export class OptimizationMode {
  RouteId: string;
  Mode: string;
  RouteDate: Date;
  Latitude: Number;
  Longitude: Number;
}
